import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { canUseDOM, loadTreatment } from '@surfline/web-common';

import { getStatusCode } from '../../selectors/status';
import {
  getUserDetails,
  getUserSettings,
  getPremiumStatus,
  getUserFavorites,
  getUserEntitlements,
} from '../../selectors/user';
import NotFound from './NotFound';

class HomepagePageContainer extends Component {
  componentDidMount() {
    const {
      flags: {
        identity: { type, userId },
      },
      doLoadTreatments,
    } = this.props;

    if (canUseDOM && window.analytics && window.analytics.user) {
      if (type === 'logged_in') {
        window.analytics.identify(userId, { sourceOrigin: 'homepage' });
      }
    }
    /**
     * These treatements are temporary and used to
     * validate the Split/Segment metrics within this app.
     */
    doLoadTreatments('homepage_only_test');
    doLoadTreatments('cross_app_only_test');
  }

  getClassName = () => {
    const { isPremium } = this.props;
    classNames({
      'sl-homepage-page-container': true,
      'sl-homepage-page-container--is-premium': isPremium,
    });
  };

  render() {
    const { children, status } = this.props;

    return (
      <div>
        <div className={this.getClassName()}>{status === 404 ? <NotFound /> : children}</div>
      </div>
    );
  }
}

HomepagePageContainer.propTypes = {
  children: PropTypes.node,
  status: PropTypes.number.isRequired,
  isPremium: PropTypes.bool.isRequired,
  flags: PropTypes.shape({
    identity: PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      userId: PropTypes.string,
    }),
  }).isRequired,
  doLoadTreatments: PropTypes.func.isRequired,
};

HomepagePageContainer.defaultProps = {
  children: null,
};

export default connect(
  (state) => ({
    status: getStatusCode(state),
    userDetails: getUserDetails(state),
    userSettings: getUserSettings(state),
    userEntitlements: getUserEntitlements(state),
    userFavorites: getUserFavorites(state),
    isPremium: getPremiumStatus(state),
    flags: state.flags,
  }),
  (dispatch) => ({
    doLoadTreatments: (treatment) => dispatch(loadTreatment(treatment)),
  })
)(HomepagePageContainer);
